export interface MenuItem {
  id: string;
  name: string;
  category: 'hamburgueres' | 'porcoes' | 'bebidas' | 'sobremesas';
  price: number;
  description: string;
  image: string;
  badge?: string;
  isPopular?: boolean;
  options?: {
    name: string;
    choices: { name: string; extraPrice: number }[];
  }[];
}

export interface ActiveOrder {
  id: string;
  customerName: string;
  items: string[];
  total: number;
  status: 'recebido' | 'preparo' | 'pronto' | 'saiu_entrega';
  elapsedMinutes: number;
  deliveryType: 'Delivery' | 'Mesa 04' | 'Retirada';
}

export const gastronomiaMenu: MenuItem[] = [
  {
    id: 'prato_001',
    name: 'Bruta Bacon Double',
    category: 'hamburgueres',
    price: 44.90,
    description: '2x Smash burgers 100g de Angus, queijo cheddar inglês derretido, 4 fatias de bacon crocante, maionese de alho defumado no pão brioche.',
    image: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?q=80&w=600&auto=format&fit=crop',
    badge: '🔥 Mais Pedido',
    isPopular: true,
    options: [
      {
        name: 'Ponto da Carne',
        choices: [
          { name: 'Ao Ponto (Rosado no centro)', extraPrice: 0 },
          { name: 'Bem Passado', extraPrice: 0 }
        ]
      },
      {
        name: 'Adicionais',
        choices: [
          { name: 'Maionese Extra da Casa', extraPrice: 4.50 },
          { name: 'Dobro de Bacon Crocante', extraPrice: 7.00 },
          { name: 'Ovo Frito na Chapa', extraPrice: 3.50 }
        ]
      }
    ]
  },
  {
    id: 'prato_002',
    name: 'Gorgonzola & Caramelized',
    category: 'hamburgueres',
    price: 46.90,
    description: 'Burger de Angus 180g na chapa, creme de gorgonzola dolce, cebola caramelizada na cerveja preta e rúcula fresca no pão australiano.',
    image: 'https://images.unsplash.com/photo-1586190848861-99aa4a171e90?q=80&w=600&auto=format&fit=crop',
    badge: '⭐ Chef\'s Special',
    isPopular: false
  },
  {
    id: 'prato_003',
    name: 'Classic Cheese Smash',
    category: 'hamburgueres',
    price: 32.90,
    description: 'Smash burger 120g, crosta crocante, cheddar americano duplo, picles da casa e molho especial Bruta.',
    image: 'https://images.unsplash.com/photo-1550547660-d9450f859349?q=80&w=600&auto=format&fit=crop',
    isPopular: false
  },
  {
    id: 'prato_004',
    name: 'Fritas Trufadas com Parmesão',
    category: 'porcoes',
    price: 29.90,
    description: 'Batata rústica corte grosso, azeite de trufas brancas, queijo parmesão ralado na hora e raspas de limão siciliano.',
    image: 'https://images.unsplash.com/photo-1573080496219-bb080dd4f877?q=80&w=600&auto=format&fit=crop',
    badge: 'Best Seller',
    isPopular: true
  },
  {
    id: 'prato_005',
    name: 'Coxinha de Costela Sem Massa',
    category: 'porcoes',
    price: 34.90,
    description: '6 unidades de coxinhas feitas 100% com costela bovina desfiada e catupiry original, empanadas na farinha panko.',
    image: 'https://images.unsplash.com/photo-1541592106381-b31e9677c0e5?q=80&w=600&auto=format&fit=crop'
  },
  {
    id: 'prato_006',
    name: 'IPA Artesanal 500ml',
    category: 'bebidas',
    price: 18.00,
    description: 'Cerveja India Pale Ale local, notas cítricas e amargor equilibrado.',
    image: 'https://images.unsplash.com/photo-1608270586620-248524c67de9?q=80&w=600&auto=format&fit=crop'
  },
  {
    id: 'prato_007',
    name: 'Milkshake de Nutella & Ninho',
    category: 'sobremesas',
    price: 26.90,
    description: 'Gelato artesanal de baunilha, ganache de Nutella pura, leite Ninho e chantilly fresco.',
    image: 'https://images.unsplash.com/photo-1572490122747-3968b75cc699?q=80&w=600&auto=format&fit=crop',
    badge: 'Irresistível'
  }
];

export const pedidosAtivosKDS: ActiveOrder[] = [
  {
    id: 'PED-#1042',
    customerName: 'Rodrigo M.',
    items: ['1x Bruta Bacon Double (Ao Ponto)', '1x Fritas Trufadas', '1x Coca-Cola Zero'],
    total: 82.80,
    status: 'preparo',
    elapsedMinutes: 8,
    deliveryType: 'Delivery'
  },
  {
    id: 'PED-#1043',
    customerName: 'Lucas B.',
    items: ['2x Classic Cheese Smash', '1x IPA Artesanal'],
    total: 83.80,
    status: 'recebido',
    elapsedMinutes: 3,
    deliveryType: 'Mesa 04'
  },
  {
    id: 'PED-#1041',
    customerName: 'Fernanda K.',
    items: ['1x Gorgonzola & Caramelized', '1x Milkshake Nutella'],
    total: 73.80,
    status: 'pronto',
    elapsedMinutes: 18,
    deliveryType: 'Retirada'
  }
];
